'use strict';
const axios = require('axios');
const qs = require('qs');

const requestPerformanceLog = request => {
  let req = request ? JSON.parse(JSON.stringify(request)) : {};
  if (req.data && req.data.token) req.data.token = `${req.data.token.substring(0, 10)}...`;
  let nrt = {
    ...req,
    startTime: performance.now(),
    endTime: null,
    totalSecondsTime: null,
    response: null,
    timeStatus: 'danger',
    sprocTime: null
  };

  const saveRequestTimer = response => {
    try {
      
      nrt.response = response;
      nrt.endTime = performance.now(); 
      nrt.totalSecondsTime = parseFloat(((nrt.endTime - nrt.startTime) / 1000).toFixed(3));
      nrt.sprocTime = typeof response.headers['x-sproc-elapsed-time'] != 'undefined' ? response.headers['x-sproc-elapsed-time'] : null;

      if (nrt.totalSecondsTime <= 1) {
        nrt.timeStatus = 'success';
      } else if (nrt.totalSecondsTime <= 2) {
        nrt.timeStatus = 'warning';
      }

      /*const strRequestTimerLog = localStorage.getItem("RequestTimerLog");
            let requestTimerLog = [];
            if(strRequestTimerLog) requestTimerLog = JSON.parse(strRequestTimerLog);
            requestTimerLog.push(nrt);
            localStorage.setItem("RequestTimerLog", JSON.stringify(requestTimerLog));*/
      if (!window.app['requestPerformanceLogs']) window.app['requestPerformanceLogs'] = [];
      window.app['requestPerformanceLogs'].push(nrt);
      return;
    } catch (err) {
      return;
    }
  };

  return saveRequestTimer;
};

module.exports = async (req, reqQS = false, enableRequestPerformanceLog = false) => {
  const saveRequestTimer = enableRequestPerformanceLog ? requestPerformanceLog(req) : null;
  let response;
  try {
    validate(req);
    let data = req.data ? (reqQS ? qs.stringify(req.data) : req.data) : undefined;
    const res = await axios({
      method: req.method ? req.method : 'GET',
      url: req.url,
      data: data,
      headers: req.headers ? req.headers : undefined,
    });
    if (enableRequestPerformanceLog) response = res;
    return res;
  } catch (error) {
    //catch error
    if (enableRequestPerformanceLog) response = error;
    if (error.response) {
      if (error.response.status == 401) {
        if (window && app) {
          app.activePage
            .openConfirm('ERPeach.com', '<div><strong>Your session has expired</strong>. <br> Please login again.</div>', [
              { label: 'Accept', type: 'secondary btn-sm', value: true },
            ])
            .then(() => {
              app.store.dispatch('rms_ui/auth/logout').then(() => {
                window.location.href = '/login';
              });
            });
        }
      }
      throw error.response.data;
    } else if (error.request) {
      throw error.request;
    } else {
      throw error.message;
    }
  } finally {
    if (enableRequestPerformanceLog) saveRequestTimer(response);
  }
};

const validate = req => {
  let errors = [];
  if (req && typeof req !== 'object') {
    errors.push({
      params: 'request must be a Object params (url, method, data, ... )',
    });
    throw errors;
  } else {
    if (req.url && typeof req.url !== 'string') {
      errors.push({
        url: 'Invalid Url',
      });
    }

    /*if(req.data){
            if(typeof req.data !== 'object' || typeof req.data !== 'string'){
                errors.push({
                    data: "Invalid data Params must be a Object"
                });
            }
        }*/

    if (req.headers) {
      if (typeof req.headers !== 'object') {
        errors.push({
          headers: 'Invalid Headers must be a Object',
        });
      }
    }

    if (errors.length === 0) {
      return true;
    } else {
      throw errors;
    }
  }
};
